export default __webpack_public_path__ + "img/pin_icons/ro_unit_b.png";